import { Container } from './styles'

type FormGroupProps = {
  children: React.ReactNode
  className?: string
} & React.HTMLAttributes<HTMLDivElement>

const FormGroup: React.FC<FormGroupProps> = ({
  children,
  className = '',
  ...rest
}) => {
  return (
    <Container className={`formGroup ${className}`} {...rest}>
      {children}
    </Container>
  )
}

export { FormGroup }
